import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  content: [],
  contentRef: null,
  contentLoaded: false
}

const getters = {
  content (state) {
    return state.content
  },
  contentRef (state) {
    return state.contentRef
  },
  contentLoaded (state) {
    return state.contentLoaded
  },
  contentByUrl (state) {
    return (contentUrl) => {
      return state.content.find(c => {
        return c.url === contentUrl
      })
    }
  },
  contentByKey (state) {
    return (contentKey) => {
      return state.content.find(c => {
        return c.key === contentKey
      })
    }
  }
}

const mutations = {
  setContent (state, payload) {
    state.content = payload
  },
  setContentRef (state, payload) {
    state.contentRef = payload
  },
  setContentLoaded (state, payload) {
    state.contentLoaded = payload
  }
}

const actions = {
  loadContent: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('content')
    ref.on('value', snapshot => {
      const content = []
      snapshot.forEach(c => {
        content.push({...c.val(), key: c.key})
      })
      store.commit('setContentRef', ref)
      store.commit('setContent', content)
      store.commit('setContentLoaded', true)
      resolve()
    })
  }),
  createContent: (store, payload) => new Promise((resolve, reject) => {
    const newContent = {...payload}
    store.getters.contentRef.push(newContent).then(() => {
      resolve(newContent)
    }).catch(err => {
      reject(err)
    })
  }),
  updateContent: (store, payload) => new Promise((resolve, reject) => {
    const newContent = {...payload}
    store.getters.contentRef.child(newContent.key).set(newContent).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  deleteContent: (store, payload) => new Promise((resolve, reject) => {
    const toDelete = {...payload}
    let sections = store.getters.sectionByContent(toDelete.key)
    if (sections.length > 0) {
      reject(new Error('Delete content failed, there are sections in this content'))
    } else {
      let found = false
      for (let course of store.getters.courses) {
        if (course.content.includes(toDelete.key)) found = true
      }
      if (found) reject(new Error('Delete content failed, this content is in use by a course'))
      store.getters.contentRef.child(toDelete.key).remove().then(() => {
        resolve()
      }).catch(err => {
        reject(err)
      })
    }
  }),
  resetContent: (store) => new Promise((resolve, reject) => {
    if (store.getters.contentRef) store.getters.contentRef.off()
    store.commit('setContent', [])
    store.commit('setContentRef', null)
    resolve()
  }),
  resetContentModule (store) {
    store.dispatch('resetContent').then(() => {
      store.dispatch('resetSections').then(() => {
        store.dispatch('resetTasks')
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/content/content.js